import { render, staticRenderFns } from "./RelatedCategoryTags.vue?vue&type=template&id=3d98ef0a&scoped=true&"
import script from "./RelatedCategoryTags.vue?vue&type=script&lang=js&"
export * from "./RelatedCategoryTags.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./RelatedCategoryTags.vue?vue&type=style&index=0&id=3d98ef0a&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3d98ef0a",
  "7a1b6e96"
  
)

export default component.exports